import { array, boolean, number, object } from "superstruct";

export const ProductStatusesResponseSchema = object({
    results: array(
        object({
            productId: number(),
            wishlistItemsCount: number(),
            productInWishlist: boolean(),
            variantsInWishlist: array(number()),
        })
    ),
});
